'use client';
import React from 'react';
import { footerStickyNavigation } from './footerEntity';
import styles from './FooterStickyNav.module.scss';

export const FooterStickyNav: React.FC = () => {
  return (
    <div className={`${styles.stickyFooter} sticky-footer`}>
      <div className="footer-actions">
        {footerStickyNavigation.map((item, i: number) => {
          return (
            <div className="footer-quick-link" key={i}>
              <a data-action={`Footer Sticky Nav Click - ${item.label}`} href={item.url}>
                <div className="icon-wrap">
                  <img alt={item.label} loading="lazy" src={item.image} />
                </div>
                <h6>{item.label}</h6>
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FooterStickyNav;
